/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


var sections = window.theme.sections;
 
var headerExtension = {
  init: function() {
    this.on('section_load', this._promiseHeaderSlideIn.bind(this));
  },
 
  _promiseHeaderSlideIn: function() {
    //override original function
  }
};
 
sections.extend('header-section', headerExtension);
// $(document).ready(function() {
//   // if( typeof(productOptions ) != "undefined" ){
//   //   for(i=0;i<productOptions.length;i++) {
//   //     $('.single-option-selector:eq('+ i +')')
//   //     .filter(function() {
//   //       return $(this).find('option').length > 1
//   //     })
//   //     .prepend('<option value="">Select A ' + productOptions[i][i] + '</option>')
//   //     .val('')
//   //     .trigger('change');
//   //   }
//   // }

//   // $('#video_player')[0].src = 'https://cdn.shopify.com/videos/c/o/v/a1dfb3e74d2c40e88c5b91096f5a7b1d.mp4';
//   // $('#video_player')[0].load();
//   // $('#video_player')[0].muted = true;
//   $('#video_player')[0].play();
  
// });

// Hero Section Carousel

// Assuming jQuery is available


$(document).ready(function() {
    const animationDuration = 40000; // Total duration of the animation in milliseconds (match your animation duration)

    const root = document.documentElement;
    const marqueeElementsDisplayed = parseInt(getComputedStyle(root).getPropertyValue("--marquee-elements-displayed"), 10);

    // Adjust target counts based on initial child counts
    const marqueeContentTargetCount = 176; // Set higher than initial 8 for ul.marquee-content
    const marqueeContent1TargetCount = 176; // Desired count for ul.marquee-content1

    // Function to duplicate marquee content based on selector and target count
    function duplicateMarqueeContent(selector, targetCount) {
        const $marqueeContent = $(selector);

        if ($marqueeContent.length > 0) {
            let currentChildCount = $marqueeContent.children().length;

            // Loop to duplicate children until the target count is reached
            while (currentChildCount < targetCount) {
                const $children = $marqueeContent.children();
                $children.each(function() {
                    if (currentChildCount >= targetCount) return false; // Exit if target count reached
                    const $clone = $(this).clone();
                    $marqueeContent.append($clone);
                    currentChildCount++;
                });
            }

            // Update CSS variable for the total elements if required
            root.style.setProperty(selector === "ul.animation-content" ? "--marquee-elements" : "--marquee-elements1", currentChildCount);
            console.log(`Final child count for ${selector}:`, currentChildCount);
        } else {
            console.error(`${selector} is not found in the DOM.`);
        }
    }

    // Function to reveal `hide-ifirst` elements after the first iteration
    function revealHiddenElements() {
      setTimeout(() => {
        $(".hide-ifirst").css("display", "block");
      }, animationDuration); // Wait for the animation duration before showing the elements
    }

    // Duplicate items in marquee-content and marquee-content1
    duplicateMarqueeContent("ul.animation-content", marqueeContentTargetCount);
    revealHiddenElements();
    // duplicateMarqueeContent("ul.marquee-content1", marqueeContent1TargetCount);

    const hostname = window.location.hostname;
    const pathname = window.location.pathname;

    // Apply only on homepage or product pages for dangleit.com or whifffresheners.myshopify.com
    const isAllowedDomain = 
      hostname === "dangleit.com" || 
      hostname === "www.dangleit.com" || 
      hostname === "whifffresheners.myshopify.com";

    const isAllowedPath = 
      pathname === "/" || 
      pathname.startsWith("/products/");

    if (isAllowedDomain && isAllowedPath) {
      const targetDiv = document.getElementById("5b3c24bf-d287-49d2-b68d-29ecbddd4a1c");
      const mainContent = document.querySelector(".main-content");
      const marquee = document.querySelector(".marquee");

      if (targetDiv && targetDiv.innerHTML.trim() !== "") {
        // Set padding-top equal to div height
        const updatePadding = () => {
          if (mainContent) {
            mainContent.style.paddingTop = `${targetDiv.offsetHeight}px`;
          }
        };
        updatePadding();
        new ResizeObserver(updatePadding).observe(targetDiv);

        // Apply marquee height only on mobile devices
        if (window.innerWidth <= 425) {
          marquee?.style.setProperty("height", "38vh", "important");
        }
      }
    }
});

function openDescriptionSidebar(id) {
  const sidebar = document.getElementById(id);
  const overlay = document.getElementById('sidebarOverlay');

  if (!sidebar) return;

  /*
   * Close another description sidebar before
   * opening the requested sidebar.
   */
  document
    .querySelectorAll('.right-sidebar.open')
    .forEach(function (openSidebarElement) {
      if (openSidebarElement !== sidebar) {
        openSidebarElement.classList.remove('open');
        openSidebarElement.setAttribute('aria-hidden', 'true');
        openSidebarElement.style.removeProperty('right');
      }
    });

  /*
   * previews.css uses the open class for both:
   *
   * Desktop: right to left animation
   * Mobile: bottom to top animation
   */
  sidebar.style.removeProperty('right');
  sidebar.classList.add('open');
  sidebar.setAttribute('aria-hidden', 'false');

  if (overlay) {
    overlay.classList.add('active');
    overlay.style.display = 'block';
  }

  document.body.classList.add('sidebar-open');
}

function closeAllSidebars() {
  document
    .querySelectorAll('.right-sidebar')
    .forEach(function (sidebar) {
      sidebar.classList.remove('open');
      sidebar.setAttribute('aria-hidden', 'true');
      sidebar.style.removeProperty('right');
    });

  const overlay = document.getElementById('sidebarOverlay');

  if (overlay) {
    overlay.classList.remove('active');
    overlay.style.display = 'none';
  }

  document.body.classList.remove('sidebar-open');

  /*
   * Reenable fields that are disabled when
   * their description sidebar is opened.
   */
  const scentSelect = document.getElementById('Scent');
  const cropSelect = document.getElementById('Crop');

  if (scentSelect) {
    scentSelect.disabled = false;
  }

  if (cropSelect) {
    cropSelect.disabled = false;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('sidebarOverlay');

  if (overlay) {
    overlay.addEventListener('click', closeAllSidebars);
  }

  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      document.querySelector('.right-sidebar.open')
    ) {
      closeAllSidebars();
    }
  });
});

  